/**
 * 인증번호 미수신 안내 하단 시트 (피그마 7_인증번호_안내_하단모달)
 */
const HELP_ITEMS = [
  '입력한 휴대폰 번호를 확인해주세요.',
  '카카오톡 알림톡 차단 여부를 확인해주세요.',
  '잠시 후 인증번호 재전송을 눌러주세요.',
];

export default function CertHelpSheet({ open, onClose }) {
  if (!open) return null;

  return (
    <div
      className="fixed inset-0 z-[110] flex items-end justify-center bg-black/80"
      role="dialog"
      aria-modal="true"
      onClick={onClose}
    >
      <div
        className="w-full max-w-[480px] rounded-t-2xl bg-white px-[30px] pb-[max(24px,env(safe-area-inset-bottom))] pt-3 shadow-[0_-5px_16px_rgba(0,0,0,0.1)]"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="mx-auto mb-6 h-1 w-10 rounded-full bg-gray02" />
        <h3 className="font-['Pretendard'] text-[20px] font-bold leading-[1.32] text-black">
          인증번호가 오지 않나요?
        </h3>
        <ul className="mt-5 flex flex-col gap-4">
          {HELP_ITEMS.map((text) => (
            <li key={text} className="flex items-center gap-2.5">
              <span
                className="flex h-6 w-6 shrink-0 items-center justify-center rounded-full bg-primary-purple-01 text-[12px] font-bold text-white"
                aria-hidden
              >
                ✓
              </span>
              <span className="font-['Pretendard'] text-[14px] text-[#2e3548]">{text}</span>
            </li>
          ))}
        </ul>
        <button
          type="button"
          onClick={onClose}
          className="mt-6 flex h-[53px] w-full items-center justify-center rounded-[10px] border-0 bg-primary-purple-01 font-['Pretendard'] text-[16px] font-bold text-white"
        >
          확인
        </button>
      </div>
    </div>
  );
}
